import React from "react";
import "./styles/therapy.css";
import MEL2 from "../../assets/MEL.2.jpg"; // Replace with your actual image path
import trees from "../../assets/trees.mp4"; // Placeholder path for your video
import ServiceWarning from "../../components/ServiceWarning";

const IndividualTherapy = () => {
  return (
    <section className="therapy-section">
      <div className="therapy-card">
        <div className="video-banner">
          <video className="therapy-video" autoPlay muted loop playsInline>
            <source src={trees} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="therapy-content">
          <h1>Individual Therapy for Adults</h1>
          <p>
            I offer individual therapy for adults navigating a range of
            emotional, relational, and psychological challenges. My approach is
            rooted in evidence-based practices and tailored to your unique needs
            and goals. Therapy offers a structured and compassionate space to
            build emotional insight and awareness, strengthen resilience and
            coping tools and create meaningful, lasting change in your life.
          </p>
          <br />
          <p>You may be considering therapy to help with:</p>
          <ul className="styled-list">
            <li>
              Emotional regulation challenges (e.g., intense or overwhelming
              emotions)
            </li>
            <li>Relationship or interpersonal difficulties</li>
            <li>Low self-esteem or self-worth struggles</li>
            <li>Questions around identity and self-development</li>
            <li>Navigating major life transitions</li>
            <li>Coping with chronic stress</li>
            <li>A desire for personal growth and deeper self-understanding</li>
          </ul>
          <br />
          <p>My clinical practice includes support for individuals facing:</p>
          <ul className="styled-list">
            <li>
              Borderline personality disorder and other personality disorders
            </li>
            <li>
              Trauma, including post-traumatic stress disorder (PTSD) and
              complex PTSD
            </li>
            <li>
              Anxiety disorders (generalized anxiety, social anxiety, etc.)
            </li>
            <li>Depression and mood-related challenges</li>
            <li>Obsessive-compulsive disorder (OCD)</li>
            <li>
              Other mental health concerns impacting day-to-day life or
              relationships
            </li>
          </ul>
          <br />
          <p>
            In our first session, we focus on building a foundation for our work
            together. You'll have the opportunity to share what has brought you
            to therapy, and I will ask guiding questions to better understand
            your experiences, needs, and priorities. This collaborative process
            helps inform a clinical understanding of your concerns and allows us
            to develop a treatment plan that will shape the direction and goals
            of our work.
          </p>
        </div>

        <div className="bottom-image-wrapper">
          <img
            src={MEL2}
            alt="Therapy session representation"
            className="therapy-image"
          />
        </div>
      </div>
      <ServiceWarning />
    </section>
  );
};

export default IndividualTherapy;
